(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["potivo-bundle"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('potivo-bundle')) return;

    class PotivoBundle extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('.shopify-section') || document;
        this.onChange = this.onChange.bind(this);
        this.onAdd = this.onAdd.bind(this);
        this.onQuantityChange = this.onQuantityChange.bind(this);

        this.addEventListener('change', this.onChange);
        this.button = this.querySelector('[data-potivo-bundle-add]');
        if (this.button) this.button.addEventListener('click', this.onAdd);
        this.root.addEventListener('change', this.onQuantityChange);
        this.updateLabel(this.selected());
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
        if (this.button) this.button.removeEventListener('click', this.onAdd);
        if (this.root) this.root.removeEventListener('change', this.onQuantityChange);
      }

      selected() {
        var checked = this.querySelector('.potivo-bundle__input:checked');
        return checked ? parseInt(checked.value, 10) : 1;
      }

      quantityInput() {
        return this.root.querySelector('input[name="quantity"]');
      }

      addButton() {
        return this.root.querySelector('button[name="add"]');
      }

      setQuantity(qty) {
        var input = this.quantityInput();
        if (!input) return false;
        input.value = String(qty);
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }

      updateLabel(qty) {
        var label = this.querySelector('[data-potivo-bundle-label]');
        if (!label) return;
        var total = qty === 2 ? this.dataset.pairKr : this.dataset.unitKr;
        label.textContent = 'Legg ' + qty + ' i handlekurven – ' + total + ' kr';
      }

      onChange(event) {
        if (!event.target.classList.contains('potivo-bundle__input')) return;
        var qty = this.selected();
        this.setQuantity(qty);
        this.updateLabel(qty);
      }

      onQuantityChange(event) {
        var input = event.target;
        if (input.name !== 'quantity' || this.contains(input)) return;
        var qty = parseInt(input.value, 10);
        var radio = this.querySelector('.potivo-bundle__input[value="' + qty + '"]');
        this.querySelectorAll('.potivo-bundle__input').forEach(function (el) { el.checked = el === radio; });
        this.updateLabel(radio ? qty : 1);
      }

      onAdd() {
        var qty = this.selected();
        var add = this.addButton();
        var status = this.querySelector('[data-potivo-bundle-status]');
        if (!this.setQuantity(qty) || !add || add.disabled) {
          if (status) status.textContent = 'Kunne ikke legge i handlekurven. Bruk knappen «Legg i handlekurven» ovenfor.';
          return;
        }
        this.button.setAttribute('aria-busy', 'true');
        add.click();
        var self = this;
        setTimeout(function () { self.button.removeAttribute('aria-busy'); }, 1200);
      }
    }

    customElements.define('potivo-bundle', PotivoBundle);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["potivo-tiers"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('potivo-tiers')) return;

    class PotivoTiers extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('.shopify-section') || document;
        this.onChange = this.onChange.bind(this);
        this.onExternalChange = this.onExternalChange.bind(this);
        this.onStepperClick = this.onStepperClick.bind(this);
        this.addEventListener('change', this.onChange);
        this.root.addEventListener('change', this.onExternalChange);
        this.root.addEventListener('click', this.onStepperClick);
        this.apply(this.selected(), false);
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
        if (this.root) {
          this.root.removeEventListener('change', this.onExternalChange);
          this.root.removeEventListener('click', this.onStepperClick);
        }
      }

      selected() {
        var checked = this.querySelector('.potivo-tiers__input:checked');
        return checked ? parseInt(checked.value, 10) : 1;
      }

      quantityInput() {
        return this.root.querySelector('.buy-buttons-block input[name="quantity"]') ||
          this.root.querySelector('input[name="quantity"]');
      }

      totalFor(qty) {
        var radio = this.querySelector('.potivo-tiers__input[value="' + qty + '"]');
        return radio ? radio.dataset.total : this.dataset.unitKr;
      }

      setQuantity(qty) {
        var input = this.quantityInput();
        if (!input) return false;
        if (String(input.value) === String(qty)) return true;
        this.syncing = true;
        input.value = String(qty);
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        input.dispatchEvent(new FocusEvent('blur'));
        this.syncing = false;
        return true;
      }

      apply(qty, updateInput) {
        var total = this.querySelector('[data-potivo-tiers-total]');
        if (total) total.textContent = this.totalFor(qty) + ' kr';
        if (updateInput !== false) this.setQuantity(qty);
      }

      onChange(event) {
        if (!event.target.classList || !event.target.classList.contains('potivo-tiers__input')) return;
        this.apply(this.selected(), true);
      }

      // Temaets +/- knapper endrer feltet uten et vanlig change-event.
      onStepperClick(event) {
        if (!event.target.closest || !event.target.closest('quantity-selector-component')) return;
        var self = this;
        setTimeout(function () { self.onExternalChange({ target: self.quantityInput() }); }, 0);
      }

      onExternalChange(event) {
        var input = event.target;
        if (this.syncing || !input || input.name !== 'quantity' || this.contains(input)) return;
        var qty = parseInt(input.value, 10);
        if (!qty || qty < 1) return;
        var radio = this.querySelector('.potivo-tiers__input[value="' + qty + '"]');
        this.querySelectorAll('.potivo-tiers__input').forEach(function (el) { el.checked = el === radio; });
        if (radio) {
          this.apply(qty, false);
          return;
        }
        // Annet antall: ordinær pris minus største pakkerabatt som gjelder (samme regel som rabattene i Shopify).
        var unit = parseInt(this.dataset.unitKr, 10);
        var best = 0;
        this.querySelectorAll('.potivo-tiers__input').forEach(function (el) {
          var n = parseInt(el.value, 10);
          var saving = n * unit - parseInt(el.dataset.total, 10);
          if (n <= qty && saving > best) best = saving;
        });
        var total = this.querySelector('[data-potivo-tiers-total]');
        if (total) total.textContent = (qty * unit - best) + ' kr';
      }
    }

    customElements.define('potivo-tiers', PotivoTiers);
  })();
  } catch(e) { console.error(e); }
})();

})();
